import actions from '../../store/actions'
import { useState } from 'react'
import { mutations } from '../../resources'
import { generateError } from '../../helpers/errors'
import { CreateMenuEntriesRequest, MenuEntriesResponse } from '../../resources/establishment/types'
import { useDispatch } from '../redux'

export const useCreateMenuEntries = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const createMenuEntries = (payload: CreateMenuEntriesRequest): Promise<MenuEntriesResponse> => {
        setInProgress(true)
        return mutations
            .createMenuEntries(payload)
            .then((response) => {
                setInProgress(false)
                dispatch(actions.setMenuEntries(response))
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        createMenuEntries,
        inProgress,
    }
}
